import React from 'react';
import RichText from '..';
import { SanityImage } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import './styles.scss';

type AuthorProps = {
  data: {
    image: SanityImage;
    name: string;
    description: any;
  }
}

function Author({ data }: AuthorProps) {
  return (
    <div className='author'>
      <div className='author-header'>
        <img
          className='author-image'
          src={urlFor(data.image).width(120).url()}
          alt={data.image.alt}
        />
        <h4 className='author-name'>{data.name}</h4>
      </div>
      <RichText value={data.description} />
    </div>
  );
}

export default Author;
